import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

const ThemeSwitcher = ({ className = "" }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`group relative inline-flex items-center justify-center rounded-full p-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 focus:ring-offset-transparent ${className}`}
      aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
    >
      <span className="absolute inset-0 rounded-full bg-white/60 dark:bg-white/10 blur-lg transition-opacity group-hover:opacity-80 opacity-0" />
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[var(--color-bg-surface)] border border-[var(--color-border-soft)] shadow-sm">
        {isDark ? (
          <Sun className="h-4 w-4 text-amber-300" />
        ) : (
          <Moon className="h-4 w-4 text-[var(--color-brand)]" />
        )}
      </span>
    </button>
  );
};

export default ThemeSwitcher;
